import { ChangeDetectionStrategy, Component, forwardRef, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'sd-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SdvorToggleComponent),
      multi: true,
    },
  ],
})
export class SdvorToggleComponent implements ControlValueAccessor {
  checked = signal(false);
  disabled = signal(false);

  private onChange: (event: any) => void;
  private onTouched: (event: any) => void;

  writeValue(value: boolean): void {
    this.checked.set(value);
  }

  setDisabledState(value: boolean): void {
    this.disabled.set(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  inputOnChange(value: boolean): void {
    this.checked.set(value);

    if (this.onChange) {
      this.onChange(value);
    }

    if (this.onTouched) {
      this.onTouched(value);
    }
  }
}
